import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { toast } from 'react-toastify';
import FileUpload from '../documentSign/FileUpload';
import Modal from '../Modal';
import { getBase64ImageMimeType } from '../../utils/file';

class FilePickerModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      signatureMode: 'upload',
      filename: '',
    };

    this.saveImage = this.saveImage.bind(this);
  }

  canvas = null;
  signatureFile = null;

  doSave(image, metadata) {
    const { onClose } = this.props;
    if (this.props.beforeSavePromise) {
      this.props.beforeSavePromise(image)
        .then(() => {
          // success callback
          this.props.onSaved(image, metadata);
          onClose();
        }, () => {
          // error callback
        });
    } else {
      this.props.onSaved(image, metadata);
      onClose();
    }
  }

  saveImage() {
    switch (this.state.signatureMode) {
      case 'upload': {
        const metadata = {};
        const mimeType = getBase64ImageMimeType(this.signatureFile) &&
          getBase64ImageMimeType(this.signatureFile).toLowerCase();
        metadata.contentType = this.signatureFileMetadata.type;
        metadata.filename = this.signatureFileMetadata.name;
        if (!mimeType) {
          toast.error('No File selected. Please select a File before continue');
          break;
        }
        this.doSave(this.signatureFile, metadata);
        break;
      }
      default:
        break;
    }
  }

  renderSignatureHandler(mode) {
    const { maxSize } = this.props;
    switch (mode) {
      case 'upload':
        return (
          <UploadWrapper>
            <FileUpload
              fileName={this.state.filename}
              onFilesLoaded={(base64Signature, file) => {
                  this.signatureFile = base64Signature;
                  this.signatureFileMetadata = file;
                  this.setState({ filename: file.name });
              }}
            />
            <p>{`Maximum upload file size: ${maxSize}MB`}</p>
            <p className="filetype">File types: PDF, DOC, DOCX</p>
          </UploadWrapper>
        );
      default:
        return null;
    }
  }

  renderModalContent() {
    return (
      <React.Fragment>
        <div>
          {this.state.textSignature}
          {this.renderSignatureHandler(this.state.signatureMode)}
        </div>
      </React.Fragment>
    );
  }

  render() {
    const { open, onClose } = this.props;
    return (
      <Modal
        title=""
        open={open}
        modal={false}
        content={this.renderModalContent()}
        primaryLabel={this.props.modalSaving ? 'Saving...' : 'Apply'}
        secondaryLabel="Cancel"
        onPrimaryClick={this.saveImage}
        onSecondaryClick={onClose}
        contentStyle={{ width: '548px' }}
        titleStyle={{ display: 'none' }}
        primaryDisabled={this.props.modalSaving}
      />
    );
  }
}

FilePickerModal.propTypes = {
  onSaved: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  maxSize: PropTypes.number,
  open: PropTypes.bool,
  modalSaving: PropTypes.bool,
  beforeSavePromise: PropTypes.func,
};

FilePickerModal.defaultProps = {
  modalSaving: false,
  open: false,
  beforeSavePromise: null,
  maxSize: 0,
};

const UploadWrapper = styled.div`
  width: 500px;
  & > p {
    font-size: 0.7rem;
    color: #979797;
    position: relative;
    bottom: 0.8rem;
  }
  & > .filetype {
    bottom: 2rem;
  }
`;

export default FilePickerModal;
